/* eslint-disable jsx-a11y/anchor-is-valid */
import {
	Button,
	Container,
	Input,
	Link,
	Logo,
	Text
} from '@descope/page-editor-components';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';

const Preview = () => {
	// prevent button animation on load
	const [btnAnimation, setBtnAnimation] = useState(false);

	useEffect(() => {
		setBtnAnimation(true);
	}, []);

	return (
		<Box>
			<Container
				direction="col"
				spaceBetween="3"
				background="100"
				paddingX="5"
				paddingY="5"
			>
				<Box display="flex">
					<Container direction="col" spaceBetween="3" background="#ffffff00">
						<Logo height={100} style={{ maxHeight: '100%' }} />
					</Container>
				</Box>
				<Container background="#ffffff00">
					<Button color="primary" animation={btnAnimation}>
						{intl.tr('styleEditor.theme.preview.button.primary')}
					</Button>
				</Container>
				<Container background="#ffffff00">
					<Button color="secondary" animation={btnAnimation}>
						{intl.tr('styleEditor.theme.preview.button.secondary')}
					</Button>
				</Container>
				<Input
					label="Label"
					value={intl.tr('styleEditor.theme.preview.input.value')}
					readOnly
				/>
				<Input
					placeholder={intl.tr('styleEditor.theme.preview.input.placeholder')}
					readOnly
				/>
				<Text typography="body1" variant="primary">
					{intl.tr('styleEditor.theme.preview.text.primary')}
				</Text>
				<Text typography="body1" variant="secondary">
					{intl.tr('styleEditor.theme.preview.text.secondary')}
				</Text>
				<Link typography="body1" color="accent">
					{intl.tr('styleEditor.theme.preview.link')}
				</Link>
				<Text typography="body1" color="error">
					{intl.tr('styleEditor.theme.preview.error')}
				</Text>
			</Container>
		</Box>
	);
};

export default Preview;
